if ($('#app-ratings-tv-audience-comp').length) {
    var book;
    var distributor;
    var day_part;

    var table_data;
    var p_base;
    var m_base;
    var f_base;
    var programs;

    var dt;
    var export_html='';

    var playback_types = {
        'LPM': {
            'LO': 'Live Only',
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'SRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'CRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'DIA': {
            'L1': 'Live Plus 1'
        }
    };

    var playback_types_all = {
        'LO': 'Live Only',
        'LS': 'Live Plus Same Day',
        'L3': 'Live Plus 3',
        'L7': 'Live Plus 7',
        'L1': 'Live Plus 1'
    };
    //
    // $('#chart_type').on('change', function(){
    //     if($(this).val() === 'pie'){
    //         $('.div_only_one_daypart').show();
    //         $('#chart_age').multiSelect('deselect_all');
    //     }
    //     else {
    //         $('.div_only_one_daypart').hide();
    //     }
    // });

    $('#custom_chart').on('click', function () {
        var html_type= ' <option value=""></option>' +
            '                                            <option value="pie">Pie</option>' +
            '                                            <option value="column">Column (Vertical)</option>' +
            '                                            <option value="bar">Column (Horizontal)</option>';

        $('#chart_type').select2({
            minimumResultsForSearch: 5,
            placeholder: 'Select one....',
        });
        $('#chart_type').html(html_type);
        $('#chart_data_type').select2({
            minimumResultsForSearch: 5
        });
        $('#chart_demo_options').select2({
            placeholder: "Select at least one..",
            closeOnSelect: false,
            placeholder: 'Select at least one....',
        });

       var table=   $('#ratings_audience_comp_table ').DataTable();
       console.log('table',table);
       var ages=[];
        table.rows().eq(0).each( function ( index ) {
            var row = table.row( index );

            var data = row.data();
            console.log('row.data', data)
            ages.push(data['ages']);
        } );
        $('#chart_age').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_dayparts'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_dayparts'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
                // if( $('#chart_type option:selected').val() === 'pie') {
                //     form_curr_dayparts = this.$element.val();
                //     if (this.$element.val().length > 1) {
                //         this.$element.multiSelect('deselect', values);
                //         form_curr_dayparts = this.$element.val();
                //
                //         swal({
                //                 title: "Warning",
                //                 text: "The max number is 1 ...",
                //                 type: "warning",
                //                 showCancelButton: true,
                //                 confirmButtonClass: "btn-danger",
                //                 confirmButtonText: "OK",
                //                 cancelButtonText: "Close",
                //                 closeOnConfirm: true,
                //                 closeOnCancel: true
                //             },
                //             function (isConfirm) {
                //
                //             });
                //     }
                //     if (form_curr_dayparts.length < 2)
                //         this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                //     else
                //         this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-muted').addClass('text-warning');
                //
                // }
            },
            afterDeselect: function (values) {
                this.qs1.cache();
                // if( $('#chart_type option:selected').val() == 'pie') {
                //     form_curr_dayparts = this.$element.val();
                //     this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                // }
            }
        });
         var html = '';
        for(var i in ages)
            html +='<option value="'+ages[i]+'">'+ages[i]+'</option>';
        $('#chart_age').html(html).multiSelect('refresh');
        $('#sel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('select_all');
        });
        $('#desel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('deselect_all');
        });

        $('#graphsOptionsModal').modal('show');
    });
    $('#submit_charts_options').on('click', function(){
        if($('#chart_type option:selected').val() == ''){
            swal({
                    title: "Warning",
                    text: "Select Chart Type first...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_demo_options').val().length == 0){
            swal({
                    title: "Warning",
                    text: "Select at least one Demo...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_age').val().length == 0){
            if($('#chart_type option:selected').val() === 'pie')
                text= 'Select a Age first...';
            else
                text= 'Select at least one Age Range...';
            swal({
                    title: "Warning",
                    text: text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else {
            show_overlay_loader('#graphsOptionsModal .modal-content');
            var age_charts = $('#chart_age').val();
            var data_type ='impressions';
            var demo_type = $('#chart_demo_options').val();
            var columns = [];
            for (var b in demo_type) {
                var string = '';
                string += demo_type[b]+'_'+data_type;
                columns.push(string);
            }
            console.log('columns', columns);
            console.log('vendor_charts', age_charts);
            console.log('demo_type', demo_type);
            var results=[];
            var results_per=[];
            var thousands_total = 0;
            for(var i in demo_type) {
                results[demo_type[i]] = [];
                results_per[demo_type[i]] = [];
                for(var y in age_charts) {
                    results[demo_type[i]][age_charts[y]] = [];
                    results_per[demo_type[i]][age_charts[y]] = [];
                }
            }
            var demo_names={
                m: 'Men',
                f: 'Women',
                p: 'Person',
            };
            console.log('results', results);

            var table=   $('#ratings_audience_comp_table ').DataTable();

            table.rows().eq(0).each( function ( index ) {
                var row = table.row( index );
                var data = row.data();
                console.log('row.data', data)
                if(age_charts.indexOf(data['ages']) !== -1 ){
                    for(var i in columns){
                        var string= columns[i].split('_');
                        results[string[0]][data['ages']][columns[i]]= (!isNaN(data[columns[i]])) ? data[columns[i]] : 0;
                        thousands_total += (!isNaN(data[columns[i]])) ? parseFloat(data[columns[i]]) : 0;
                        results_per[string[0]][data['ages']][string[0]+'_per']= (!isNaN(data[string[0]+'_per'])) ? data[string[0]+'_per'] : 0;
                    }
                }
            });

            console.log('results', results);

            if ($('#chart_type option:selected').val() == 'column' || $('#chart_type option:selected').val() == 'bar') {
                var series=[];
                for(var demo in results){
                    var data=[];
                    for(var age in results[demo]){
                        for(var col in results[demo][age]){
                            var string= col.split('_');
                            var perc= string[0]+'_per';
                            if($('#chart_data_type option:selected').val() == 'both') {
                                data.push({
                                    name: age,
                                    y: parseFloat(results[demo][age][col]),
                                    percentage: parseFloat(results_per[demo][age][perc]),
                                    drilldown: null,
                                });
                            }
                            else if($('#chart_data_type option:selected').val() == 'impressions'){
                                data.push({
                                    name: age,
                                    y: parseFloat(results[demo][age][col]),
                                   // percentage: parseFloat(results_per[demo][age][perc]),
                                    drilldown: null,
                                });
                            }
                            else{
                                data.push({
                                    name: age,
                                    y: parseFloat(results_per[demo][age][perc]),
                                    drilldown: null,
                                });
                            }
                        }
                    }
                    series.push({
                        name: demo_names[demo],
                        data: data,
                    });
                }
                console.log('series', series)
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.percentage:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.y:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Thousands (000) & Percent (%)';

                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text: $('#book').html(),
                    },
                    subtitle:{
                        text:  $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ' )',
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        column: {
                            pointPadding: 0.2,
                            borderWidth: 0
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px"><b>{point.key}</b></span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:5 px">'+ format +'</td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    series: series,
                });
            }
            else{
                var series = [];
                var data2 = [];
                for(var demo in results){
                    var total = 0;
                    var arr= [];
                    var cont=0;
                    for(var age in results[demo]){
                        var total_age= 0;
                        for(var col in results[demo][age]){
                            var string= col.split('_');
                            var perc= string[0]+'_per';
                            total += parseFloat(results[demo][age][col]);
                            total_age += parseFloat(results[demo][age][col]);
                        }
                        arr.push({name: age, y: total_age, x: parseFloat(results_per[demo][age][perc]), drilldown: null});
                        cont++;
                    }
                    data2.push({
                        name: demo_names[demo],
                        id: demo,
                        data: arr,
                    });
                    // if( $('#chart_data_type option:selected').val() == 'per' && cont > 1)
                    //     total = total / cont;
                    var percent = 0;
                    percent= (thousands_total > 0) ? parseFloat(((total * 100) / thousands_total)).toFixed(2) : 0;
                    console.log('thousands_total', thousands_total);
                    console.log('total', total);
                    console.log('percent', percent);
                    series.push({
                        name: demo_names[demo],
                        y: total,
                        x: percent,
                        drilldown: demo,
                    });
                }
                console.log('data2', data2);
                console.log('series', series)
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.x:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.x:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Thousands (000) & Percent (%)';

                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type_name = "Thousands";
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type_name = "Percent"
                else
                    dt_type_name = 'Thousands & Percent';
                Highcharts.setOptions(Highcharts.theme);
                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text: $('#book').html(),
                    },
                    subtitle:{
                       // text:  $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ' ) '+ \n + ' Click the slices to view ' + $('#chart_data_type option:selected').html() +' by Age Range. ',
                        text:    $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ')<br> <span style="color: red"> Click the slices to view  '+ dt_type +' by Age Range. </span>',
                      // text: 'Source: <br><span style="color:red">WorldClimate.com</span>',
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true,
                                // format: '${point.y:.2f}'
                            },
                            showInLegend: true,
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px"><b>{point.key}</b></span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">'+ dt_type_name +': </td>' +
                            '<td style="padding: 5px"><b>' +format + '</b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    series: [
                        {
                            name: 'Thousands',
                            colorByPoint: true,
                            data: series
                        }
                    ],
                    drilldown: {
                        series: data2
                    }
                });
            }

            $('#GraphsModal').modal('show');
            hide_overlay_loader('#graphsOptionsModal .modal-content');
        }
    });

    $(document).ready(function(){
        show_loader();
        dayPartInputInit('16:00', '23:00', 'tv');
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/markets',
            dataType: 'json',
            success: function (data) {
                var input = $('#form_market');
                data = collect(data).sortBy('name').all();

                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    input.append('<option value="' + index + '">' + value['name'] + '</option>')
                });

                form_markets = data;

                input.select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {
                    ratingsCompAudienceOnMarketChange(this);
                });

                $('#form_playback_type').select2({
                    placeholder: "Select a market...",
                    minimumResultsForSearch: 10
                });

                $('#form_book').select2({
                    placeholder: "Select a data stream...",
                    minimumResultsForSearch: 10
                });

                $('#form_dist').select2({
                    placeholder: "Select a book...",
                    minimumResultsForSearch: 10
                });

                $('#form_reset').bind('click', function(){
                    ratingsCompAudienceReset();
                });

                $('#form_submit').bind('click', function(){
                    ratingsCompAudienceSubmit();
                });

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    });

    var ratingsCompAudienceOnMarketChange = function(select) {
        form_curr_market = form_markets[$(select).val()];
        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/allbooks/?dma=' + form_curr_market['dma'],
            dataType: 'json',
            success: function (data) {
                console.log("books");
                //console.log(data);
                console.log(collect(data).keyBy('playback_type').all());
                var form_playbacks = collect(data).sortBy('name').keyBy('playback_type').all();

                var input = $('#form_playback_type');
                input.attr('disabled', null);
                input.data('select2').destroy();
                input.unbind('select2:select');

                input.html('').append('<option value=""></option>');
                $.each(form_playbacks, function (index, value) {
                    input.append('<option value="' + index + '">' + playback_types_all[index] + '</option>')
                });

                input.select2({
                    placeholder: "Select...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {
                    ratingsCompAudienceOnPlaybackChange(this);
                });

                ratingsCompAudienceReset(1);

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
        /*form_playbacks = playback_types[form_curr_market['type']];

        var input = $('#form_playback_type');

        input.attr('disabled', null);
        input.data('select2').destroy();
        input.unbind('select2:select');

        input.html('').append('<option value=""></option>');
        $.each(form_playbacks, function (index, value) {
            input.append('<option value="' + index + '">' + value + '</option>')
        });

        input.select2({
            placeholder: "Select...",
            minimumResultsForSearch: 10
        }).on('select2:select', function (evt) {
            ratingsCompAudienceOnPlaybackChange(this);
        });

        ratingsCompAudienceReset(1);
        */
    };

    var ratingsCompAudienceOnPlaybackChange = function(select) {
        form_curr_playback = $(select).val();

        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/allbooks/?dma=' + form_curr_market['dma'] + '&playback=' + form_curr_playback,
            dataType: 'json',
            success: function (data) {
                form_books = data;
                var input = $('#form_book');

                input.attr('disabled', null);
                input.data('select2').destroy();
                input.unbind('select2:select');

                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    input.append('<option value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>')
                });

                input.select2({
                    placeholder: "Select...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {
                    ratingsCompAudienceOnBookChange(this);
                });

                ratingsCompAudienceReset(2);

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };

    var ratingsCompAudienceOnBookChange = function(select) {
        form_curr_book = $(select).val();

        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/books/distributors/?books[]=' + form_curr_book,
            dataType: 'json',
            success: function (data) {
                form_dists = data;

                var html_broadcast = '';
                var html_cable = '';

                var input = $('#form_dist');
                input.attr('disabled', null);
                input.data('select2').destroy();
                input.unbind('select2:select');

                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    if (value['affil'] !== null) {
                        html_broadcast = html_broadcast + '<option value="' + value['id'] + '">'
                            + value['name'] + ' (' + value['affil'] + ')</option>';
                    } else {
                        html_cable = html_cable + '<option value="' + value['id'] + '">' + value['name'] + '</option>';
                    }
                });

                input.append('<optgroup label="Broadcast">' + html_broadcast + '</optgroup>');
                input.append('<optgroup label="Cable">' + html_cable + '</optgroup>');

                input.select2({
                    placeholder: "Select...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {
                    ratingsCompAudienceOnStationChange(this);
                });

                ratingsCompAudienceReset(3);

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };

    var ratingsCompAudienceOnStationChange = function(select)
    {
        if($(select).val() !== ''){
            $('#form_submit').attr('disabled', null);
        }

    };

    var ratingsCompAudienceReset = function(step){
        if(typeof step === 'undefined'){
            step = 'all';
        }

        if(step === 'all') {
            var input = $('#form_market');

            input.data('select2').destroy();
            input.unbind('select2:select');

            input.html('').append('<option value=""></option>');
            $.each(form_markets, function (index, value) {
                input.append('<option value="' + index + '">' + value['name'] + '</option>')
            });

            input.attr('disabled', null);
            input.select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 10
            }).on('select2:select', function (evt) {
                ratingsCompAudienceOnMarketChange(this);
            });

            input = $('#form_playback_type');

            input.data('select2').destroy();
            input.unbind('select2:select');
            input.html('');
            input.attr('disabled', 'disabled');
            input.select2({
                placeholder: "Select a market...",
                minimumResultsForSearch: 10
            });
        }

        if((step < 2) || (step === 'all')) {
            input = $('#form_book');

            input.data('select2').destroy();
            input.unbind('select2:select');
            input.html('');
            input.attr('disabled', 'disabled');
            input.select2({
                placeholder: "Select a data stream...",
                minimumResultsForSearch: 10
            });
        }

        if((step < 3) || (step === 'all')) {
            input = $('#form_dist');
            input.data('select2').destroy();
            input.unbind('select2:select');
            input.html('');
            input.attr('disabled', 'disabled');
            input.select2({
                placeholder: "Select a book...",
                minimumResultsForSearch: 10
            });

            $('#form_submit').attr('disabled', 'disabled');
        }
    };

    var ratingsCompAudienceSubmit = function(){
        show_loader();
        $('#nielsen-disclaimer').find('.intab-disclaimer-individual').addClass('hidden');

        book = $('#form_book').val();
        distributor = $('#form_dist').val();

        dp_start = moment($('#form_day_part_start').val(), 'h:mm A');
        dp_end = moment($('#form_day_part_end').val(), 'h:mm A');

        day_part = $('#form_day_part_days').val() + dp_start.format('HHmm') + dp_end.format('HHmm');

        $.ajax({
            url: '/ratings/tv/local/books/composition/audience?' + $.param({
                day_part: day_part,
                book: book,
                distributor: distributor
            }),
            success: function (data) {
                console.log(data);

                var change = {
                    "2-5": 'undefined',
                    "6-11": 'undefined',
                    "12-17": 'undefined',
                    "18-24": 'undefined',
                    "25-34": 'undefined',
                    "35-49": 'undefined',
                    "50-64": 'undefined',
                    "65+": 'undefined',
                };
                $.each(data['impressions'], function(index, value) {
                    if (index === "12-14" || index === "15-17") {
                        if (change["12-17"] !== 'undefined') {
                            change["12-17"]['P']['impressions'] += value['P']['impressions'];
                            change["12-17"]['M']['impressions'] += value['M']['impressions'];
                            change["12-17"]['F']['impressions'] += value['F']['impressions'];
                        } else {
                            change["12-17"] = {
                                'P': {'impressions': value['P']['impressions'], 'intab': value['P']['intab']},
                                'F': {'impressions': value['M']['impressions'], 'intab': value['F']['intab']},
                                'M': {'impressions': value['F']['impressions'], 'intab': value['M']['intab']}
                            };
                        }
                    } else if (index === "18-20" || index === "21-24") {
                        if (change["18-24"] !== 'undefined') {
                            change["18-24"]['P']['impressions'] += value['P']['impressions'];
                            change["18-24"]['M']['impressions'] += value['M']['impressions'];
                            change["18-24"]['F']['impressions'] += value['F']['impressions'];
                        } else {
                            change["18-24"] = {
                                'P': {'impressions': value['P']['impressions'], 'intab': value['P']['intab']},
                                'F': {'impressions': value['M']['impressions'], 'intab': value['F']['intab']},
                                'M': {'impressions': value['F']['impressions'], 'intab': value['M']['intab']}
                            };
                        }
                    } else if (index === "50-54" || index === "55-64") {
                        if (change["50-64"] !== 'undefined') {
                            change["50-64"]['P']['impressions'] += value['P']['impressions'];
                            change["50-64"]['M']['impressions'] += value['M']['impressions'];
                            change["50-64"]['F']['impressions'] += value['F']['impressions'];
                        } else {
                            change["50-64"] = {
                                'P': {'impressions': value['P']['impressions'], 'intab': value['P']['intab']},
                                'F': {'impressions': value['M']['impressions'], 'intab': value['F']['intab']},
                                'M': {'impressions': value['F']['impressions'], 'intab': value['M']['intab']}
                            };
                        }
                    } else {
                        change[index] = value;
                    }
                });
                data['impressions'] = change;

                table_data = [];

                $('#book').html(data['book']['market']['name'] + '; ' + data['book']['month'] + '/'
                    + data['book']['year'] + '; ' + data['book']['playback_type']);
                $('#distributor').html(data['distributor']['call_letters']);
                $('#day_part').html(ratingsHumanDaypart(day_part));

                programs = collect(Object.values(data['programs'])).sortByDesc('count').all();

                $('#programs').html('');
                collect(programs).take(5).each(function(item){
                    $('#programs').append('<li><i class="fa fa-fw fa-angle-double-right text-primary"></i>&nbsp;' + item['name'] + '</li>');
                });

                if(collect(programs).count() > 5){
                    $('#programs').append('<li><i class="fa fa-fw fa-angle-double-right text-primary"></i>&nbsp;VARIOUS (' + (collect(programs).count() - 5) +')</li>');
                }
                /*$.each(data['impressions'], function(index, value){
                    if($.inArray(index, ['2+', '12+']) === -1){
                        var m = 0;
                        var f = 0;
                        if(typeof data['impressions'][index]['M'] !== 'undefined'){
                            m = (Math.ceil(data['impressions'][index]['M']['impressions'] / 1000) * 1000) - data['impressions'][index]['M']['impressions'];
                            mm_base += m;
                        }
                        if(typeof data['impressions'][index]['F'] !== 'undefined'){
                            f = (Math.ceil(data['impressions'][index]['F']['impressions'] / 1000) * 1000) - data['impressions'][index]['F']['impressions'];
                            ff_base += f;
                        }
                        pp_base += f + m;
                    }
                });*/

                p_base = ((data['impressions']['2+']['P']['impressions']));
                m_base = ((data['impressions']['12+']['M']['impressions']));
                f_base = ((data['impressions']['12+']['F']['impressions']));

                /*p_base=0; m_base=0; f_base=0;
                $.each(data['impressions'], function(index, value){
                    if(typeof value['P'] !== 'undefined') {
                        var p = Math.round(value['P']['impressions'] / 1000) * 1000;
                        if (value['P']['impressions'] - p > 400)
                            p = Math.ceil(value['P']['impressions'] / 1000) * 1000;
                        data['impressions'][index]['P']['impressions'] = p;
                        p_base += p;
                    }
                    if(typeof value['M'] !== 'undefined') {
                        var m = Math.round(value['M']['impressions'] / 1000) * 1000;
                        if (value['M']['impressions'] - m > 400)
                            m = Math.ceil(value['M']['impressions'] / 1000) * 1000;
                        data['impressions'][index]['M']['impressions'] = m;
                        m_base += m;
                    }
                    if(typeof value['F'] !== 'undefined') {
                        var f = Math.round(value['F']['impressions'] / 1000) * 1000;
                        if (value['F']['impressions'] - f > 400)
                            f = Math.ceil(value['F']['impressions'] / 1000) * 1000;
                        data['impressions'][index]['F']['impressions'] = f;
                        f_base += f;
                    }
                });*/


                $.each(data['impressions'], function(index, value){
                    if($.inArray(index, ['2+', '12+']) === -1){
                        push = {
                            'ages': index
                        };

                        if(typeof data['impressions'][index]['M'] === 'undefined'){
                            push['m_impressions'] = 'N/A';
                            push['m_per'] = "N/A";
                            push['m_intab'] = true;
                        }else{
                            push['m_impressions'] = Math.ceil(data['impressions'][index]['M']['impressions'] / 1000).toLocaleString("en-US", {
                                minimumFractionDigits: 0
                            });
                            push['m_per'] = Number(Math.ceil(((Math.round(data['impressions'][index]['M']['impressions']/1000) / Math.ceil(p_base/1000)) * 100) +'e1')+'e-1');
                            push['m_intab'] = data['impressions'][index]['M']['intab'];
                        }

                        if(typeof data['impressions'][index]['F'] === 'undefined'){
                            push['f_impressions'] = 'N/A';
                            push['f_per'] = "N/A";
                            push['f_intab'] = true;
                        }else{
                            push['f_impressions'] = Math.ceil(data['impressions'][index]['F']['impressions'] / 1000).toLocaleString("en-US", {
                                minimumFractionDigits: 0
                            });
                            push['f_per'] = Number(Math.round(((Math.ceil(data['impressions'][index]['F']['impressions'] / 1000) / Math.ceil(p_base/1000)) * 100) +'e1')+'e-1');
                            push['f_intab'] = data['impressions'][index]['F']['intab'];
                        }

                        push['p_impressions'] = Math.ceil(data['impressions'][index]['P']['impressions'] / 1000).toLocaleString("en-US", {
                            minimumFractionDigits: 0
                        });
                        push['p_per'] = Number(Math.round(((Math.ceil(data['impressions'][index]['P']['impressions'] / 1000) / Math.ceil(p_base/1000)) * 100) +'e1')+'e-1');
                        push['p_intab'] = data['impressions'][index]['P']['intab'];

                        table_data.push(push);
                    }

                });


                if(typeof dt !== 'undefined'){
                    dt.destroy();
                    $('#ratings_audience_comp_table').find('tbody').empty();
                }

                dt = $('#ratings_audience_comp_table').DataTable( {
                    columns: [
                        {
                            data: "ages"
                        },{
                            data: "m_impressions"
                        },{
                            data: "m_per"
                        },{
                            data: "f_impressions"
                        },{
                            data: "f_per"
                        },{
                            data: "p_impressions"
                        },{
                            data: "p_per"
                        }
                    ],
                    "columnDefs": [
                        {
                            "orderable": false,
                            "targets": '_all'
                        },
                        {
                            render: function ( data, type, row, meta ) {
                                var curr_intab = true;
                                var html = '';
                                if(meta['col'] === 2){
                                    if(! row['m_intab']){
                                        html += '<span class="pull-left">✝</span>';
                                        curr_intab = false;
                                    }
                                }else if(meta['col'] === 4){
                                    if(! row['f_intab']){
                                        html += '<span class="pull-left">✝</span>';
                                        curr_intab = false;
                                    }
                                }else if(meta['col'] === 6){
                                    if(! row['p_intab']){
                                        html += '<span class="pull-left">✝</span>';
                                        curr_intab = false;
                                    }
                                }

                                if(! curr_intab){
                                    var disclaimer = $('#nielsen-disclaimer');
                                    if(disclaimer.find('.intab-disclaimer-individual').hasClass('hidden')){
                                        disclaimer.find('.intab-disclaimer-individual').removeClass('hidden');
                                    }
                                }

                                html += data;
                                export_html= html;
                                return html;
                            },
                            targets: [2, 4, 6]
                        },
                    ],
                    "order": [],
                 //   dom: 'Bfrtip',
                   /* buttons: [
                        'copy',
                        {
                            extend: 'excel',
                            messageTop:  $('#book').html() +' >  ' + $('#distributor').html() +' >  '+ $('#day_part').html(),
                        },
                        {
                            extend: 'csv',
                            messageTop:  $('#book').html() +' >  ' + $('#distributor').html() +' >  '+ $('#day_part').html(),
                        },
                        {
                            extend: 'print',
                            messageTop:   $('#book').html() +' >  ' + $('#distributor').html() +' >  '+ $('#day_part').html(),
                        },
                    ],*/
                    "searching": false,
                    "paging": false,
                    "info": false,
                    data: table_data,
                } );
                var td=  $('#ratings_audience_comp_table td');
                for(var i in td)
                {
                    if(td[i].innerHTML== '2-5')
                        td[i].innerHTML= '(2 - 5)';
                    if(td[i].innerHTML== '6-11')
                        td[i].innerHTML= '(6 - 11)';
                    if(td[i].innerHTML== '12-17')
                        td[i].innerHTML= '(12 - 17)';
                    if(td[i].innerHTML== '18-24')
                        td[i].innerHTML= '(18 - 24)';
                    if(td[i].innerHTML== '25-34')
                        td[i].innerHTML= '(25 - 34)';
                    if(td[i].innerHTML== '35-49')
                        td[i].innerHTML= '(35 - 49 )';
                    if(td[i].innerHTML== '50-64')
                        td[i].innerHTML= '(50 - 64)';
                    if(td[i].innerHTML== '65+')
                        td[i].innerHTML= '(65+)';

                }

                if($('.ratings-table-container').hasClass('hidden')){
                    $('.ratings-table-container').removeClass('hidden');
                }

                ratingsCompAudienceReset();
                $('#tv_comp_audience_generate_panel').find('div.clickable').click();

                hide_loader();
            }
        });
    };
    $('#export_excel_aud').on('click', function(){
     var x= $('#book').html() +' >  ' + $('#distributor').html() +' >  '+ $('#day_part').html();

        var html_header= '<table> ' +
                            '<tr> ' +
            '<td style="background-color: #f5f5f5" colspan="10"><span style="font-size: 18px">  <b> Television Ratings Audience Composition<b></span></td>' +
                            '</tr> ' +
            '<tr></tr></table><table>' +
            '<tr>' +
            '<td style="background-color: #f5f5f5; font-size: 15px " colspan="10"> ' + x+ '</td></tr>' +
            '<tr></tr>' +
                        '</table>';

        $("#ratings_audience_comp_table th:contains(Men)")
            .css("background-color", "#f2643d");
        $("#ratings_audience_comp_table th:contains(Women)")
            .css("background-color", "#f2643d");
        $("#ratings_audience_comp_table th:contains(Persons)")
            .css("background-color", "#f2643d");

        $("#ratings_audience_comp_table th:contains(Demo)")
            .parents("tr")
            .css("background-color", "#f8ab91");

        $("#ratings_audience_comp_table tbody tr:odd")
            .css("background-color", "#f0ffff");

        $("#ratings_audience_comp_table tbody td")
            .css("padding", "80px");
        
        html_header += $('.audience-ratings-table').html();
        html_header = html_header.replace(/✝/g, "");


        exportToExcel(html_header);


    });

    function exportToExcel(html){
        var url='data:application/vnd.ms-excel,' + encodeURIComponent(html);
        location.href=url;
        return false;
    }
}